import EnterpriseModel               from 'Models/directory/EnterpriseModel';
import OrderTypeModel                from 'Models/supplier/OrderTypeModel';
import SupplierEnterpriseStatusModel from 'Models/supplier/SupplierEnterpriseStatusModel';
import doc                           from 'decorators/doc';
import model                         from 'decorators/model';
import { Timestampable }             from 'helpers/traits';
import { Blamable }                  from 'helpers/traits';
import SupplierPrivateApiModel       from 'modelx/models/abstracts/SupplierPrivateApiModel';

@model.staticLabel('Fournisseur')
@model.urnResource('supplier_enterprise')
@doc.path('/supplier_enterprises/{?id}')
export default class SupplierEnterpriseModel extends Blamable(Timestampable(SupplierPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'defaultOrderType.reference': SupplierOrderTypeReference;
		'defaultPurchaseCondition': id;
		'enterpriseUrn': Urn;
		'supplierEnterpriseStatus': id;
		'supplierEnterpriseStatus.reference': SupplierSupplierEnterpriseStatusReference;
		'updatedAt[after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedAt[strictly_before]': string | Date;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'updatedAt': string;
	}> = {};

	@doc.modelUrn(EnterpriseModel) declare enterprise: EnterpriseModel;
	@doc.number declare number: number;
	@doc.string declare reference: SupplierSupplierEnterpriseReference;
	@doc.model(SupplierEnterpriseStatusModel) declare supplierEnterpriseStatus: SupplierEnterpriseStatusModel;
	@doc.model(OrderTypeModel) declare defaultOrderType: OrderTypeModel;
}